export function createAuthInterceptor({ http, auth }) {
  return (request, next) => {
    const isAuth = request.url.includes('/auth/v2/');
    const isTracking = request.url.includes('/api/tracking/location');
    if (isAuth) request.headers.delete('x-lecard-key');
    if (isAuth || isTracking) return next();

    const session = auth.credentials();
    const headers = {};
    request.headers.forEach((value, name) => { headers[name] = value; });
    const retryOptions = { ...request, headers, authRetried: true };
    if (session.token) request.headers.set('x-lecard-key', `Bearer ${session.token}`);

    next(async response => {
      if (response.status !== 401 || !session.key || request.authRetried) return response;
      try {
        if (!await auth.renew(session)) return response;
        return await http(retryOptions);
      } catch (error) {
        return error && typeof error.status === 'number' && !error.ok ? error : response;
      }
    });
  };
}
